<form [formGroup]="formCompanyAddress" class="mt-2">

  <!-- HEADER -->
  <div class="border-b pb-4">
    <p class="font-medium text-base text-westetics-neutral-950">
      Endereço
    </p>
    <p class="text-sm text-westetics-neutral-800 mt-2">
      Informe o endereço da sua empresa
    </p>
  </div>

  <!-- CEP -->
  <div class="mt-4">
    <div class="w-full">
      <label for="cep" class="block mb-2 text-sm font-medium text-westetics-neutral-950">CEP*</label>
      <div class="relative">
        <input
          maxlength="9"
          type="text"
          id="cep"
          formControlName="cep"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="00000-000"
          (input)="onCepInput($event)"
        />
        <div *ngIf="isLoadingCep" class="absolute right-3 top-1/2 -translate-y-1/2">
          <app-loading-spinner size="sm"></app-loading-spinner>
        </div>
      </div>
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyAddress.controls['cep']?.invalid &&
        formCompanyAddress.controls['cep']?.touched
      ">
        Insira um CEP válido.
      </span>
    </div>
  </div>

  <!-- NOME DA RUA -->
  <div class="mt-4">
    <div class="w-full">
      <label for="street" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Nome da Rua*</label>
      <input
        type="text"
        id="street"
        formControlName="street"
  class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="Insira o nome da rua"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyAddress.controls['street']?.invalid &&
        formCompanyAddress.controls['street']?.touched
      ">
        Insira o nome da rua.
      </span>
    </div>
  </div>

  <!-- NÚMERO E COMPLEMENTO -->
  <div class="mt-4 grid grid-cols-2 gap-4">
    <div class="w-full">
      <label for="number" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Número*</label>
      <input
        type="text"
        id="number"
        formControlName="number"
  class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="Número"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyAddress.controls['number']?.invalid &&
        formCompanyAddress.controls['number']?.touched
      ">
        Insira o número.
      </span>
    </div>

    <div class="w-full">
      <label for="complement" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Complemento</label>
      <input
        type="text"
        id="complement"
        formControlName="complement"
  class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="Apto, Bloco, Sala..."
      />
    </div>
  </div>

  <!-- BAIRRO -->
  <div class="mt-4">
    <div class="w-full">
      <label for="neighborhood" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Bairro*</label>
      <input
        type="text"
        id="neighborhood"
        formControlName="neighborhood"
  class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="Insira o bairro"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyAddress.controls['neighborhood']?.invalid &&
        formCompanyAddress.controls['neighborhood']?.touched
      ">
        Insira o bairro.
      </span>
    </div>
  </div>

  <!-- CIDADE E ESTADO -->
  <div class="mt-4 grid grid-cols-2 gap-4">
    <div class="w-full">
      <label for="city" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Cidade*</label>
      <input
        type="text"
        id="city"
        formControlName="city"
  class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="Insira a cidade"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyAddress.controls['city']?.invalid &&
        formCompanyAddress.controls['city']?.touched
      ">
        Insira a cidade.
      </span>
    </div>

    <div class="w-full">
      <label for="state" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Estado*</label>
      <input
        type="text"
        id="state"
        formControlName="state"
        class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
        placeholder="UF"
        maxlength="2"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyAddress.controls['state']?.invalid &&
        formCompanyAddress.controls['state']?.touched
      ">
        Insira o estado.
      </span>
    </div>
  </div>

  <!-- ACTION -->
  <div class="flex justify-between mt-6">
    <button
      type="button"
      (click)="goBack()"
      class="w-[306px] py-[10px] text-westetics-purple-800 rounded-lg border border-westetics-purple-800"
    >
      Voltar
    </button>

    <button
      type="button"
      (click)="saveAndNext()"
      class="w-[306px] py-[10px] bg-westetics-purple-800 text-white rounded-lg"
    >
      Próximo
    </button>
  </div>

</form>
